export function testWebm() {
  // Check for WebM support
  var testEl = document.createElement("video");
  return testEl.canPlayType('video/webm; codecs="vp8, vorbis"') === "probably";
}

export function testMp4() {
  // Check for MP4 support
  var testEl = document.createElement("video");
  return testEl.canPlayType('video/mp4; codecs="mp4v.20.8"') === "probably";
}

export const showWidget = (statusObj, status, planObj, plan) => {
  // Expired Trial User
  if (
    statusObj.EXPIRED === status &&
    (planObj.TEAM_FREE === plan || plan.FREE === plan)
  ) {
    return false;
  } else if (plan === planObj.INTERNAL) {
    // Internal User
    return false;
  }
  return true;
};

export function buildResolveUrl(path) {
  let resolveUrl = "";
  const commonScript = document.querySelector(
    "script[src*='adskf.common.entry.js']"
  );

  if (commonScript) {
    resolveUrl = commonScript.getAttribute("data-resolve-menu-url")
      ? commonScript.getAttribute("data-resolve-menu-url")
      : "";
  }

  return resolveUrl + path;
}

export async function fetchJson(path) {
  try {
    let url = buildResolveUrl(path);
    let response = await fetch(url);
    let json = await response.json();
    return json;
  } catch (error) {
    console.error(error);
    return false;
  }
}

export function createTargetId(targetProp){
  // Formatting for test and analytics ids: 
  // transform to kebab case, remove parens & content (ex: "(Beta)"), remove trailing dashes
  return targetProp.replace(/\s+/g, '-').replace(/\([^)]*\)/g, '').replace(/-+$/, '').toString().toLowerCase()
}
